import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=0e4a0542&scoped=true&"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&id=0e4a0542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4a0542",
  null
  
)

export default component.exports